const stammdatenApiUrl = '$HUS_STAMMDATEN_API_URL'
const keycloakRedirectUri = '$HUS_KEYCLOAK_REDIRECT_URI'
const keycloakRealmUri = '$HUS_KEYCLOAK_REALM_URI'
const keycloakAdminRealmUri = '$HUS_KEYCLOAK_ADMIN_REALM_URI'
const keycloakAuthUri = '$HUS_KEYCLOAK_AUTH_URI'
const keycloakClientId = '$HUS_KEYCLOAK_CLIENT_ID'
const keycloakRealm = '$HUS_KEYCLOAK_REALM'
const disableAuth = '$VITE_DISABLE_AUTH'

export function useEnv() {
  const {
    DEV,
    MODE,
    BASE_URL,
    VITE_STAMMDATEN_API_URL: STAMMDATEN_API_URL,
    VITE_KEYCLOAK_REDIRECT_URI: KEYCLOAK_REDIRECT_URI,
    VITE_KEYCLOAK_REALM_URI: KEYCLOAK_REALM_URI,
    VITE_KEYCLOAK_ADMIN_REALM_URI: KEYCLOAK_ADMIN_REALM_URI,
    VITE_KEYCLOAK_AUTH_URI: KEYCLOAK_AUTH_URI,
    VITE_KEYCLOAK_CLIENT_ID: KEYCLOAK_CLIENT_ID,
    VITE_KEYCLOAK_REALM: KEYCLOAK_REALM,
    VITE_DISABLE_AUTH: VITE_DISABLE_AUTH
  } = import.meta.env
  return {
    DEV,
    MODE,
    BASE_URL,
    AUTH_DISABLED: disableAuth.startsWith('$')
      ? VITE_DISABLE_AUTH === 'true'
      : disableAuth === 'true',
    STAMMDATEN_API_URL: stammdatenApiUrl.startsWith('$') ? STAMMDATEN_API_URL : stammdatenApiUrl,
    KEYCLOAK_REDIRECT_URI: keycloakRedirectUri.startsWith('$')
      ? KEYCLOAK_REDIRECT_URI
      : keycloakRedirectUri,
    KEYCLOAK_REALM_URI: keycloakRealmUri.startsWith('$') ? KEYCLOAK_REALM_URI : keycloakRealmUri,
    KEYCLOAK_ADMIN_REALM_URI: keycloakAdminRealmUri.startsWith('$')
      ? KEYCLOAK_ADMIN_REALM_URI
      : keycloakAdminRealmUri,
    KEYCLOAK_AUTH_URI: keycloakAuthUri.startsWith('$') ? KEYCLOAK_AUTH_URI : keycloakAuthUri,
    KEYCLOAK_CLIENT_ID: keycloakClientId.startsWith('$') ? KEYCLOAK_CLIENT_ID : keycloakClientId,
    KEYCLOAK_REALM: keycloakRealm.startsWith('$') ? KEYCLOAK_REALM : keycloakRealm
  }
}
